import { render, staticRenderFns } from "./account-item.vue?vue&type=template&id=58b3e2f5&scoped=true&"
import script from "./account-item.vue?vue&type=script&lang=js&"
export * from "./account-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b3e2f5",
  null
  
)

export default component.exports